import { Action } from '@ngrx/store';

export const LOAD_CULTURES = '[Site-context] Load Cultures';
export const LOAD_CULTURES_FAIL = '[Site-context] Load Cultures Fail';
export const LOAD_CULTURES_SUCCESS = '[Site-context] Load Cultures Success';
export const SET_ACTIVE_CULTURE = '[Site-context] Set Active Culture';
export const SET_ACTIVE_CURRENCY = '[Site-context] Set Active Currency';
export const SET_ACTIVE_LANGUAGE = '[Site-context] Set Active Language';

export class LoadCultures implements Action {
  readonly type = LOAD_CULTURES;
}

export class LoadCulturesFail implements Action {
  readonly type = LOAD_CULTURES_FAIL;
  constructor(public payload: any) {}
}

export class LoadCulturesSuccess implements Action {
  readonly type = LOAD_CULTURES_SUCCESS;
  constructor(public payload: { baseSites: any[] }) {}
}

export class SetActiveCulture implements Action {
  readonly type = SET_ACTIVE_CULTURE;
  constructor(public payload: string) {}
}

export class SetActiveCurrency implements Action {
  readonly type = SET_ACTIVE_CURRENCY;
  constructor(public payload: string) {}
}

export class SetActiveLanguage implements Action {
  readonly type = SET_ACTIVE_LANGUAGE;
  constructor(public payload: string) {}
}

// action types
export type CulturesAction =
  | LoadCultures
  | LoadCulturesFail
  | LoadCulturesSuccess
  | SetActiveCulture
  | SetActiveCurrency
  | SetActiveLanguage;
